import { VillaSearchPropertiesType } from "@website/accommodation-ui/villa-search/villa-search.types";
import { DatepickerSelectedDateType } from "@website/ui/datepicker";
import { useCallback, useEffect, useState } from "react";

export const useValidation = ({
  acceptEmpty = false,
  selectedDestinationItem,
  date,
  initialDestinationItem,
  searchType
}: {
  selectedDestinationItem: any;
  date: DatepickerSelectedDateType;
  initialDestinationItem?: any;
  acceptEmpty?: boolean;
} & Pick<VillaSearchPropertiesType, "searchType">) => {
  const [destinationError, setDestinationError] = useState<string>("");
  const [dateError, setDateError] = useState<string>("");

  useEffect(() => {
    setDestinationError("");
  }, [selectedDestinationItem]);

  useEffect(() => {
    setDateError("");
  }, [date]);

  const submitValidationCheck = useCallback(() => {
    let hasError = false;

    if (
      !(selectedDestinationItem || initialDestinationItem) &&
      searchType !== "villa"
    ) {
      setDestinationError("لطفا مقصد خود را انتخاب نمایید.");
      hasError = true;
    }

    if ((!date || !date[0] || !date[1]) && !acceptEmpty) {
      setDateError("لطفا تاریخ ورود و خروج خود را انتخاب نمایید.");
      hasError = true;
    }

    return !hasError;
  }, [date, initialDestinationItem, searchType, selectedDestinationItem]);

  return { dateError, destinationError, submitValidationCheck };
};
